import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUserLogger = (params) => {
    return axios.get(`${backendHost}/api/admin/user-logger/view`, {params});
};

export {
    getUserLogger
}